import type { AnchorHTMLAttributes, ReactNode } from 'react'

/**
 * A link that looks like a button and opens a new tab safely.
 *
 * `rel="noopener noreferrer"` is not optional: without it the opened page keeps
 * a handle on this one through `window.opener`. "opens in a new tab" is part of
 * the accessible name because a link that silently changes context is a trap
 * for anyone not watching the viewport.
 */
export function ExternalLinkButton({ href, variant = 'secondary', size = 'md', block = false, children, ...props }: AnchorHTMLAttributes<HTMLAnchorElement> & { href: string; variant?: 'primary' | 'secondary' | 'ghost' | 'link'; size?: 'sm' | 'md' | 'lg'; block?: boolean; children: ReactNode }) {
  return <a {...props} href={href} target="_blank" rel="noopener noreferrer" className={`ui-button ui-button-${variant} ui-button-${size} ui-button-link-external${block ? ' ui-button-block' : ''} ${props.className ?? ''}`}><span className="ui-button-content">{children}<span className="sr-only"> (opens in a new tab)</span></span></a>
}
